import { LoaderFunctionArgs, Outlet } from 'react-router-dom';

import { TCustomRouteObject, THandle } from '@/shared/types/router.types';
import { PipelineConfigurationFragment } from '@/shared/types/types.generated';

export const pipelineInnerRoutes: TCustomRouteObject[] = [
  {
    path: ':pipelineConfigurationId/edit',
    lazy: async () => {
      const { UpdatePipelineRoute } = await import('./update-pipeline');
      return { Component: UpdatePipelineRoute };
    },
    loader: async (args: LoaderFunctionArgs) => {
      const { updatePipelineLoader } = await import('./update-pipeline');
      return updatePipelineLoader(args);
    },
    handle: {
      crumb: {
        label: 'edit_pipeline',
        localized: true,
      },
    },
  },
  {
    path: ':pipelineConfigurationId/:tabId?',
    lazy: async () => {
      const { PipelineRoute } = await import('./pipeline');
      return { Component: PipelineRoute };
    },
    shouldRevalidate: () => false,
    loader: async (args: LoaderFunctionArgs) => {
      const { pipelineLoader } = await import('./pipeline');
      return pipelineLoader(args);
    },
    handle: {
      crumb: {
        label: (data: PipelineConfigurationFragment) => data.name,
      },
    },
  },
];

export const pipelinesRoutesHandle: THandle = {
  crumb: {
    label: 'pipelines',
    localized: true,
  },
  entity: 'Pipeline',
};

export const pipelinesRoutes: TCustomRouteObject = {
  path: '/pipelines',
  Component: () => <Outlet />,
  handle: pipelinesRoutesHandle,
  children: [
    {
      index: true,
      lazy: async () => {
        const { PipelinesListRoute } = await import('./pipelines-list');
        return { Component: PipelinesListRoute };
      },
    },
    {
      path: 'new',
      lazy: async () => {
        const { CreatePipelineRoute } = await import('./create-pipeline');
        return { Component: CreatePipelineRoute };
      },
      handle: {
        crumb: {
          label: 'new_pipeline',
          localized: true,
        },
      },
    },
    ...pipelineInnerRoutes,
  ],
};
